import Layout from '@/layout';
import routerView from "@/components/otherTpl/routerView";

// 法务
export default {
    path: '/legalAffairs',
    redirect: '/legalAffairs/contract/resourceContract/index',
    component: Layout,
    alwaysShow: true,
    meta: {
        title: '合同',
        icon: 'menu_fw',
        modules: [13000]
    },
    children: [
        {
            path: 'contract',
            component: routerView,
            redirect: '/legalAffairs/contract/resourceContract/index',
            meta: {
                title: '资源',
                icon: 'spot',
                modules: [13040]
            },
            children: [
                {
                    path: 'resourceContract',
                    component: routerView,
                    redirect: '/legalAffairs/contract/resourceContract/index',
                    meta: {
                        title: '资源合同',
                        modules: [13001]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'ResourceContractList',
                            component: () => import('@/views/legalAffairs/resource/resourceContract/index'),
                            meta: {
                                breadcrumb: false,
                                title: '资源合同',
                                keepAlive: true,
                                modules: [13001]
                            }
                        },
                        {
                            path: 'add',
                            name: 'AddResourceContract',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/resource/resourceContract/contractForm'),
                            meta: {
                                title: '新增资源合同',
                                activeMenu: '/legalAffairs/contract/resourceContract/index',
                                modules: [13001]
                            }
                        },
                        {
                            path: 'addProportion',
                            name: 'AddProportionResourceContract',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/resource/resourceContract/contractForm'),
                            meta: {
                                title: '新增资源合同',
                                activeMenu: '/legalAffairs/contract/resourceContract/index',
                                modules: [13001]
                            }
                        },
                        {
                            path: 'edit/:id',
                            name: 'EditResourceContract',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/resource/resourceContract/contractForm'),
                            meta: {
                                title: '编辑资源合同',
                                activeMenu: '/legalAffairs/contract/resourceContract/index',
                                modules: [13001]
                            }
                        },
                        {
                            path: 'renew/:id/:relate',
                            name: 'RenewResourceContract',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/resource/resourceContract/contractForm'),
                            meta: {
                                title: '新增资源合同',
                                activeMenu: '/legalAffairs/contract/resourceContract/index',
                                modules: [13001]
                            }
                        },
                        {
                            path: 'change/:id',
                            name: 'ResourceContractChange',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/resource/resourceContract/contractChange'),
                            meta: {
                                title: '资源合同变更',
                                activeMenu: '/legalAffairs/contract/resourceContract/index',
                                modules: [13001]
                            }
                        },
                        {
                            path: 'detail/:id',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/resource/resourceContract/contractDetail'),
                            meta: {
                                title: '资源合同详情',
                                activeMenu: '/legalAffairs/contract/resourceContract/index',
                                modules: [13001],
                                isDetail: true
                            }
                        },
                        {
                            path: 'detail/:list/:id',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/resource/resourceContract/contractDetail'),
                            meta: {
                                title: '资源合同详情',
                                activeMenu: '/legalAffairs/contract/resourceContract/index',
                                modules: [13001]
                            }
                        },
                        {
                            path: 'history/:id',
                            name: 'ResourceContractHistory',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/resource/resourceContract/historyContract'),
                            meta: {
                                title: '历史合同',
                                activeMenu: '/legalAffairs/contract/resourceContract/index',
                                modules: [13001]
                            }
                        }
                    ]
                },
                {
                    path: 'resourceChange',
                    component: routerView,
                    redirect: '/legalAffairs/contract/resourceChange/index',
                    meta: {
                        title: '资源合同变更',
                        modules: [13002]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'ResourceChangeList',
                            component: () => import('@/views/legalAffairs/resource/resourceChange/index'),
                            meta: {
                                breadcrumb: false,
                                title: '资源合同变更',
                                keepAlive: true,
                                modules: [13002]
                            }
                        },
                        //  合同变更--详情
                        {
                            path: 'detail/:id',
                            name: 'ResourceChangeDetail',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/resource/resourceChange/changeDetail'),
                            meta: {
                                title: '合同变更详情',
                                activeMenu: '/legalAffairs/contract/resourceChange/index',
                                modules: [13002],
                                isDetail: true
                            }
                        },
                        //  合同变更--详情
                        {
                            path: 'detail/:list/:id',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/resource/resourceChange/changeDetail'),
                            meta: {
                                title: '合同变更详情',
                                activeMenu: '/legalAffairs/contract/resourceChange/index',
                                modules: [13002],
                                isDetail: true
                            }
                        }
                    ]
                },
                {
                    path: 'paymentApply',
                    name: 'PaymentApply',
                    component: routerView,
                    redirect: '/legalAffairs/contract/paymentApply/index',
                    meta: {
                        title: '付款申请审核',
                        modules: [13003]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'PaymentApplyList',
                            component: () => import('@/views/legalAffairs/resource/paymentApply/index'),
                            meta: {
                                breadcrumb: false,
                                title: '付款申请审核',
                                keepAlive: true,
                                modules: [13003]
                            }
                        },
                        {
                            path: 'detail/:list/:id',
                            name: 'PaymentApplyDetail',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/resource/paymentApply/applyDetail'),
                            meta: {
                                title: '付款申请详情',
                                activeMenu: '/legalAffairs/contract/paymentApply/index',
                                modules: [13003]
                            }
                        },
                        {
                            path: 'detail/:id',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/resource/paymentApply/applyDetail'),
                            meta: {
                                title: '付款申请详情',
                                activeMenu: '/legalAffairs/contract/paymentApply/index',
                                modules: [13003]
                            }
                        }
                    ]
                },
                //  收票
                {
                    path: 'invoice',
                    redirect: '/legalAffairs/contract/invoice/index',
                    component: routerView,
                    meta: {
                        title: '资源合同收票',
                        modules: [13041]
                    },
                    children: [
                        //  收票列表
                        {
                            path: 'index',
                            name: 'invoiceList',
                            component: () => import('@/views/legalAffairs/resource/invoiceList/index'),
                            meta: {
                                breadcrumb: false,
                                activeMenu: '/legalAffairs/contract/invoice/index',
                                title: '资源合同收票',
                                keepAlive: true,
                                modules: [13041]
                            }
                        },
                        //  新增收票
                        {
                            path: 'addInvoice',
                            name: 'addInvoice',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/resource/invoiceList/invoiceForm'),
                            meta: {
                                title: '新增收票',
                                activeMenu: '/legalAffairs/contract/invoice/index',
                                modules: [13041]
                            }
                        },
                        //  编辑收票
                        {
                            path: 'editInvoice/:id',
                            name: 'editInvoice',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/resource/invoiceList/invoiceForm'),
                            meta: {
                                title: '编辑收票',
                                activeMenu: '/legalAffairs/contract/invoice/index',
                                modules: [13041]
                            }
                        },
                        //  收票详情
                        {
                            path: 'invoiceDetail/:id',
                            name: 'invoiceDetail',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/resource/invoiceList/invoiceDetail'),
                            meta: {
                                title: '收票详情',
                                activeMenu: '/legalAffairs/contract/invoice/index',
                                modules: [13041],
                                isDetail: true
                            }
                        }
                    ]
                }
            ]
        },
        {
            path: 'outsource',
            component: routerView,
            redirect: '/legalAffairs/outsource/outsourceContract/index',
            meta: {
                title: '外采',
                icon: 'spot',
                modules: [13020]
            },
            children: [
                // 线下外采合同
                {
                    path: 'outsourceContract',
                    name: 'OutsourceContract',
                    redirect: '/legalAffairs/outsource/outsourceContract/index',
                    component: routerView,
                    meta: {
                        title: '线下外采合同',
                        modules: [13004]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'OutsourceContractList',
                            component: () => import('@/views/legalAffairs/outsource/offlineContract/index'),
                            meta: {
                                breadcrumb: false,
                                title: '线下外采合同',
                                keepAlive: true,
                                modules: [13004]
                            }
                        },
                        //  外采合同--新增采购合同
                        {
                            path: 'add',
                            name: 'AddOutContract',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/offlineContract/contractForm'),
                            meta: {
                                title: '新增线下外采合同',
                                activeMenu: '/legalAffairs/outsource/outsourceContract/index',
                                modules: [13004]
                            }
                        },
                        //  外采合同--新增框架合同
                        {
                            path: 'addFramework',
                            name: 'AddFrameworkOutContract',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/offlineContract/contractForm'),
                            meta: {
                                title: '新增线下外采合同',
                                activeMenu: '/legalAffairs/outsource/outsourceContract/index',
                                modules: [13004]
                            }
                        },
                        //  外采合同--编辑
                        {
                            path: 'edit/:id',
                            name: 'EditOutContract',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/offlineContract/contractForm'),
                            meta: {
                                title: '编辑外采合同',
                                activeMenu: '/legalAffairs/outsource/outsourceContract/index',
                                modules: [13004]
                            }
                        },
                        //  外采合同--变更
                        {
                            path: 'change/:id',
                            name: 'ResOutContractChange',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/offlineContract/contractChange'),
                            meta: {
                                title: '外采合同变更',
                                activeMenu: '/legalAffairs/outsource/outsourceContract/index',
                                modules: [13004]
                            }
                        },
                        //  外采合同--详情
                        {
                            path: 'detail/:list/:id',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/offlineContract/contractDetail'),
                            meta: {
                                title: '外采合同详情',
                                activeMenu: '/legalAffairs/outsource/outsourceContract/index',
                                modules: [13004]
                            }
                        },
                        //  外采合同--详情
                        {
                            path: 'detail/:id',
                            name: 'ResOutContractDetails',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/offlineContract/contractDetail'),
                            meta: {
                                title: '外采合同详情',
                                activeMenu: '/legalAffairs/outsource/outsourceContract/index',
                                modules: [13004],
                                isDetail: true
                            }
                        },
                        //  外采合同--历史
                        {
                            path: 'history/:id',
                            name: 'ResOutContractHistory',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/offlineContract/contractHistory'),
                            meta: {
                                title: '历史合同',
                                activeMenu: '/legalAffairs/outsource/outsourceContract/index',
                                modules: [13004]
                            }
                        }
                    ]
                },
                // 线上外采合同
                {
                    path: 'onlineOutsourceContract',
                    name: 'OnlineOutsourceContract',
                    redirect: '/legalAffairs/outsource/onlineOutsourceContract/online',
                    component: routerView,
                    meta: {
                        title: '线上外采合同',
                        modules: [13007]
                    },
                    children: [
                        {
                            path: 'online',
                            name: 'OnlineOutsourceContractList',
                            component: () => import('@/views/legalAffairs/outsource/onlineContract/index'),
                            meta: {
                                breadcrumb: false,
                                title: '线上外采合同',
                                keepAlive: true,
                                modules: [13007]
                            }
                        },
                        //  线上外采合同--新增采购合同
                        {
                            path: 'addOnline',
                            name: 'AddOnlineOutContract',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/onlineContract/contractForm'),
                            meta: {
                                title: '新增线上外采合同',
                                activeMenu: '/legalAffairs/outsource/onlineOutsourceContract/online',
                                modules: [13007]
                            }
                        },
                        //  线上外采合同--新增框架合同
                        {
                            path: 'addOnlineFramework',
                            name: 'AddOnlineFrameworkOutContract',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/onlineContract/contractForm'),
                            meta: {
                                title: '新增线上外采合同',
                                activeMenu: '/legalAffairs/outsource/onlineOutsourceContract/online',
                                modules: [13007]
                            }
                        },
                        //  线上外采合同--编辑
                        {
                            path: 'editOnline/:id',
                            name: 'EditOnlineOutContract',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/onlineContract/contractForm'),
                            meta: {
                                title: '编辑外采合同',
                                activeMenu: '/legalAffairs/outsource/onlineOutsourceContract/online',
                                modules: [13007]
                            }
                        },
                        //  线上外采合同--变更
                        {
                            path: 'onlineChange/:id',
                            name: 'OnlineResOutContractChange',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/onlineContract/contractChange'),
                            meta: {
                                title: '外采合同变更',
                                activeMenu: '/legalAffairs/outsource/onlineOutsourceContract/online',
                                modules: [13007]
                            }
                        },
                        //  线上外采合同--详情
                        {
                            path: 'onlineDetail/:list/:id',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/onlineContract/contractDetail'),
                            meta: {
                                title: '外采合同详情',
                                activeMenu: '/legalAffairs/outsource/onlineOutsourceContract/online',
                                modules: [13007]
                            }
                        },
                        //  线上外采合同--详情
                        {
                            path: 'onlineDetail/:id',
                            name: 'OnlineResOutContractDetails',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/onlineContract/contractDetail'),
                            meta: {
                                title: '外采合同详情',
                                activeMenu: '/legalAffairs/outsource/onlineOutsourceContract/online',
                                modules: [13007],
                                isDetail: true
                            }
                        },
                        //  线上外采合同--历史
                        {
                            path: 'onlineHistory/:id',
                            name: 'OnlineResOutContractHistory',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/onlineContract/contractHistory'),
                            meta: {
                                title: '历史合同',
                                activeMenu: '/legalAffairs/outsource/onlineOutsourceContract/online',
                                modules: [13007]
                            }
                        }
                    ]
                },
                // 线下外采合同变更
                {
                    path: 'outsourceChange',
                    name: 'OutsourceChange',
                    redirect: '/legalAffairs/outsource/outsourceChange/index',
                    component: routerView,
                    meta: {
                        title: '线下外采合同变更',
                        modules: [13009]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'OutsourceChangeList',
                            component: () => import('@/views/legalAffairs/outsource/offlineChange/index'),
                            meta: {
                                title: '线下外采合同变更',
                                breadcrumb: false,
                                keepAlive: true,
                                modules: [13009]
                            }
                        },
                        //  合同变更--详情
                        {
                            path: 'detail/:id',
                            name: 'OutsourceChangeDetails',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/offlineChange/changeDetail'),
                            meta: {
                                title: '线下合同变更详情',
                                activeMenu: '/legalAffairs/outsource/outsourceChange/index',
                                modules: [13009],
                                isDetail: true
                            }
                        },
                        //  合同变更--详情
                        {
                            path: 'detail/:list/:id',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/offlineChange/changeDetail'),
                            meta: {
                                title: '线下合同变更详情',
                                activeMenu: '/legalAffairs/outsource/outsourceChange/index',
                                modules: [13009]
                            }
                        }
                    ]
                },
                // 线上外采合同变更
                {
                    path: 'onlineOutsourceChange',
                    name: 'OnlineOutsourceChange',
                    redirect: '/legalAffairs/outsource/onlineOutsourceChange/online',
                    component: routerView,
                    meta: {
                        title: '线上外采合同变更',
                        modules: [13008]
                    },
                    children: [
                        {
                            path: 'online',
                            name: 'OnlineOutsourceChangeList',
                            component: () => import('@/views/legalAffairs/outsource/onlineChange/index'),
                            meta: {
                                title: '线上外采合同变更',
                                breadcrumb: false,
                                keepAlive: true,
                                modules: [13008]
                            }
                        },
                        //  合同变更--详情
                        {
                            path: 'onlineDetail/:id',
                            name: 'OnlineOutsourceChangeDetails',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/onlineChange/changeDetail'),
                            meta: {
                                title: '线上合同变更详情',
                                activeMenu: '/legalAffairs/outsource/onlineOutsourceChange/online',
                                modules: [13008],
                                isDetail: true
                            }
                        },
                        //  合同变更--详情
                        {
                            path: 'onlineDetail/:list/:id',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/outsource/onlineChange/changeDetail'),
                            meta: {
                                title: '线上合同变更详情',
                                activeMenu: '/legalAffairs/outsource/onlineOutsourceChange/online',
                                modules: [13008]
                            }
                        }
                    ]
                }
            ]
        },
        {
            path: 'sales',
            component: routerView,
            redirect: '/legalAffairs/sales/offlineSalesContract/offline',
            meta: {
                title: '销售',
                icon: 'spot',
                modules: [13030]
            },
            children: [
                //  线下销售合同
                {
                    path: 'offlineSalesContract',
                    name: 'OfflineSalesContract',
                    redirect: '/legalAffairs/sales/offlineSalesContract/offline',
                    component: routerView,
                    meta: {
                        title: '线下销售合同',
                        modules: [13005]
                    },
                    children: [
                        //  销售合同
                        {
                            path: 'offline',
                            name: 'OfflineSalesContractList',
                            component: () => import('@/views/legalAffairs/sales/offlineContract/index'),
                            meta: {
                                breadcrumb: false,
                                title: '线下销售合同',
                                activeMenu: '/legalAffairs/sales/offlineSalesContract/offline',
                                keepAlive: true,
                                modules: [13005]
                            }
                        },
                        //  销售合同--新增
                        {
                            path: 'addSalesContract',
                            name: 'AddSalesContract',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/offlineContract/contractForm'),
                            meta: {
                                title: '新增合同',
                                activeMenu: '/legalAffairs/sales/offlineSalesContract/offline',
                                modules: [13005]
                            }
                        },

                        //  销售合同--编辑
                        {
                            path: 'editSalesContract/:id',
                            name: 'EditSalesContract',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/offlineContract/contractForm'),
                            meta: {
                                title: '编辑销售合同',
                                activeMenu: '/legalAffairs/sales/offlineSalesContract/offline',
                                modules: [13005]
                            }
                        },

                        //  销售合同--变更
                        {
                            path: 'salesContractChange/:id',
                            name: 'SalesContractChange',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/offlineContract/contractChange'),
                            meta: {
                                title: '销售合同变更',
                                activeMenu: '/legalAffairs/sales/offlineSalesContract/offline',
                                modules: [13005]
                            }
                        },

                        //  销售合同--详情
                        {
                            path: 'salesContractDetail/:id',
                            name: 'SalesContractDetail',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/offlineContract/contractDetail'),
                            meta: {
                                title: '销售合同详情',
                                activeMenu: '/legalAffairs/sales/offlineSalesContract/offline',
                                modules: [13005],
                                isDetail: true
                            }
                        },
                        //  销售合同--详情
                        {
                            path: 'salesContractDetail/:list/:id',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/offlineContract/contractDetail'),
                            meta: {
                                title: '销售合同详情',
                                activeMenu: '/legalAffairs/sales/offlineSalesContract/offline',
                                modules: [13005]
                            }
                        },

                        //  销售合同--历史
                        {
                            path: 'salesContractHistory/:id',
                            name: 'SalesContractHistory',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/offlineContract/historyContract'),
                            meta: {
                                title: '历史合同',
                                activeMenu: '/legalAffairs/sales/offlineSalesContract/offline',
                                modules: [13005]
                            }
                        }


                    ]
                },
                //  线上销售合同
                {
                    path: 'onlineSalesContract',
                    name: 'OnlineSalesContract',
                    redirect: '/legalAffairs/sales/onlineSalesContract/online',
                    component: routerView,
                    meta: {
                        title: '线上销售合同',
                        modules: [13011]
                    },
                    children: [
                        //  销售合同
                        {
                            path: 'online',
                            name: 'OnlineSalesContractList',
                            component: () => import('@/views/legalAffairs/sales/onlineContract/index'),
                            meta: {
                                breadcrumb: false,
                                title: '线上销售合同',
                                activeMenu: '/legalAffairs/sales/onlineSalesContract/online',
                                keepAlive: true,
                                modules: [13011]
                            }
                        },
                        //  销售合同--新增
                        {
                            path: 'addOnlineContractForNew',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/onlineContract/contractForm'),
                            meta: {
                                title: '新增合同                                ',
                                activeMenu: '/legalAffairs/sales/onlineSalesContract/online',
                                modules: [13011]
                            }
                        },
                        {
                            path: 'addOnlineContractForRenew/:id',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/onlineContract/contractForm'),
                            meta: {
                                title: '续费销售合同',
                                activeMenu: '/legalAffairs/sales/onlineSalesContract/online',
                                modules: [13011]
                            }
                        },
                        {
                            path: 'addOnlineContractForQuick/:id',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/onlineContract/contractForm'),
                            meta: {
                                title: '续费销售合同',
                                activeMenu: '/legalAffairs/sales/onlineSalesContract/online',
                                modules: [13011]
                            }
                        },

                        {
                            path: 'editOnlineContract/:id',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/onlineContract/contractForm'),
                            meta: {
                                title: '编辑销售合同',
                                activeMenu: '/legalAffairs/sales/onlineSalesContract/online',
                                modules: [13011]
                            }
                        },

                        {
                            path: 'onlineSalesContractChange/:id',
                            name: 'OnlineSalesContractChange',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/onlineContract/contractChange'),
                            meta: {
                                title: '销售合同变更',
                                activeMenu: '/legalAffairs/sales/onlineSalesContract/online',
                                modules: [13011]
                            }
                        },

                        //  销售合同--详情
                        {
                            path: 'onlineSalesContractDetail/:id',
                            name: 'OnlineSalesContractDetail',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/onlineContract/contractDetail'),
                            meta: {
                                title: '销售合同详情',
                                activeMenu: '/legalAffairs/sales/onlineSalesContract/online',
                                modules: [13011],
                                isDetail: true
                            }
                        },
                        //  销售合同--详情
                        {
                            path: 'onlineSalesContractDetail/:list/:id',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/onlineContract/contractDetail'),
                            meta: {
                                title: '销售合同详情',
                                activeMenu: '/legalAffairs/sales/onlineSalesContract/online',
                                modules: [13011]
                            }
                        },

                        //  线上销售合同--历史
                        {
                            path: 'onlineSalesContractHistory/:id',
                            name: 'OnlineSSalesContractHistory',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/onlineContract/historyContract'),
                            meta: {
                                title: '历史合同',
                                activeMenu: '/legalAffairs/sales/onlineSalesContract/online',
                                modules: [13011]
                            }
                        }

                    ]
                },
                // 线下销售合同变更
                {
                    path: 'offlineSalesChange',
                    name: 'OfflineSalesChange',
                    redirect: '/legalAffairs/sales/offlineSalesChange/offline',
                    component: routerView,
                    meta: {
                        title: '线下销售合同变更',
                        modules: [13010]
                    },
                    children: [
                        {
                            path: 'offline',
                            name: 'OfflineSalesChangeList',
                            component: () => import('@/views/legalAffairs/sales/offlineChange/index'),
                            meta: {
                                breadcrumb: false,
                                title: '线下销售合同变更',
                                activeMenu: '/legalAffairs/sales/offlineSalesChange/offline',
                                keepAlive: true,
                                modules: [13010]
                            }
                        },
                        //  合同变更--详情
                        {
                            path: 'contractChangeDetails/:id',
                            name: 'SalesChangeDetails',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/offlineChange/changeDetail'),
                            meta: {
                                title: '合同变更详情',
                                activeMenu: '/legalAffairs/sales/offlineSalesChange/offline',
                                modules: [13010],
                                isDetail: true
                            }
                        },
                        //  合同变更--详情
                        {
                            path: 'contractChangeDetails/:list/:id',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/offlineChange/changeDetail'),
                            meta: {
                                title: '合同变更详情',
                                activeMenu: '/legalAffairs/sales/offlineSalesChange/offline',
                                modules: [13010]
                            }
                        }

                    ]
                },
                // 线上销售合同变更
                {
                    path: 'onlineSalesChange',
                    name: 'OnlineSalesChange',
                    redirect: '/legalAffairs/sales/onlineSalesChange/online',
                    component: routerView,
                    meta: {
                        title: '线上销售合同变更',
                        modules: [13012]
                    },
                    children: [
                        {
                            path: 'online',
                            name: 'OnlineSalesChangeList',
                            component: () => import('@/views/legalAffairs/sales/onlineChange/index'),
                            meta: {
                                breadcrumb: false,
                                title: '线上销售合同变更',
                                activeMenu: '/legalAffairs/sales/onlineSalesChange/online',
                                keepAlive: true,
                                modules: [13012]
                            }
                        },

                        //  合同变更--详情
                        {
                            path: 'onlineContractChangeDetails/:id',
                            name: 'OnlineSalesChangeDetails',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/onlineChange/changeDetail'),
                            meta: {
                                title: '合同变更详情',
                                activeMenu: '/legalAffairs/sales/onlineSalesChange/online',
                                modules: [13012],
                                isDetail: true
                            }
                        },
                        //  合同变更--详情
                        {
                            path: 'onlineContractChangeDetails/:list/:id',
                            hidden: true,
                            component: () => import('@/views/legalAffairs/sales/onlineChange/changeDetail'),
                            meta: {
                                title: '合同变更详情',
                                activeMenu: '/legalAffairs/sales/onlineSalesChange/online',
                                modules: [13012]
                            }
                        }
                    ]
                }
            ]
        },
        // 通用合同
        {
            path: 'generalContract',
            component: routerView,
            redirect: '/legalAffairs/generalContract/index',
            meta: {
                title: '通用合同',
                icon: 'spot',
                modules: [13070]
            },
            children: [
                {
                    path: 'index',
                    name: 'GeneralContract',
                    component: () => import('@/views/legalAffairs/generalContract/index'),
                    meta: {
                        breadcrumb: false,
                        title: '通用合同',
                        activeMenu: '/legalAffairs/generalContract/index',
                        keepAlive: true,
                        modules: [13070]
                    }
                },
                {
                    path: 'generalDetail/:tab/:id',
                    name: 'GeneralDetail',
                    hidden: true,
                    component: () => import('@/views/legalAffairs/generalContract/generalDetail'),
                    meta: {
                        title: '通用合同详情',
                        isDetail: true,
                        modules: [13070],
                        activeMenu: '/legalAffairs/generalContract/index'
                    }
                },
                {
                    path: 'addGeneralForm',
                    name: 'AddGeneralForm',
                    hidden: true,
                    component: () => import('@/views/legalAffairs/generalContract/generalForm'),
                    meta: {
                        title: '新增通用合同',
                        modules: [13070],
                        activeMenu: '/legalAffairs/generalContract/index'
                    }
                },
                {
                    path: 'editGeneralForm/:id',
                    name: 'EditGeneralForm',
                    hidden: true,
                    component: () => import('@/views/legalAffairs/generalContract/generalForm'),
                    meta: {
                        title: '编辑通用合同',
                        modules: [13070],
                        activeMenu: '/legalAffairs/generalContract/index'
                    }
                }
            ]
        },
        // 合同发票
        {
            path: 'contractInvoice',
            component: routerView,
            redirect: '/legalAffairs/contractInvoice/index',
            meta: {
                title: '合同发票',
                icon: 'spot',
                keepAlive: true,
                modules: [13060]
            },
            children: [
                {
                    path: 'index',
                    name: 'ContractInvoice',
                    component: () => import('@/views/legalAffairs/contractInvoice/index'),
                    meta: {
                        breadcrumb: false,
                        title: '合同发票',
                        keepAlive: true,
                        modules: [13060]
                    }
                },
                {
                    path: 'invoiceDetail/:id',
                    name: 'InvoiceDetail',
                    hidden: true,
                    component: () => import('@/views/legalAffairs/contractInvoice/invoiceDetail'),
                    meta: {
                        title: '申请发票详情',
                        isDetail: true,
                        modules: [13060],
                        keepAlive: true,
                        activeMenu: '/legalAffairs/contractInvoice/index'
                    }
                },
                {
                    path: 'addInvoiceForm',
                    name: 'AddInvoiceForm',
                    hidden: true,
                    component: () => import('@/views/legalAffairs/contractInvoice/invoiceForm'),
                    meta: {
                        title: '申请发票',
                        modules: [13060],
                        keepAlive: true,
                        activeMenu: '/legalAffairs/contractInvoice/index'
                    }
                },
                {
                    path: 'editInvoiceForm/:id',
                    name: 'EditInvoiceForm',
                    hidden: true,
                    component: () => import('@/views/legalAffairs/contractInvoice/invoiceForm'),
                    meta: {
                        title: '编辑发票',
                        modules: [13060],
                        keepAlive: true,
                        activeMenu: '/legalAffairs/contractInvoice/index'
                    }
                }
            ]
        },
        // 合同工具
        {
            path: 'toolBox',
            component: routerView,
            redirect: 'index',
            meta: {
                title: '合同工具箱',
                icon: 'spot',
                modules: [13006]
            },
            children: [
                {
                    path: 'index',
                    name: 'ContractTool',
                    component: () => import('@/views/legalAffairs/toolBox/index'),
                    meta: {
                        breadcrumb: false,
                        title: '合同工具箱',
                        modules: [13006]
                    }
                },
                {
                    path: 'resouce',
                    name: 'ContractDelivery',
                    hidden: true,
                    component: () => import('@/views/legalAffairs/toolBox/resouce'),
                    meta: {
                        title: '资源合同交接',
                        keepAlive: true,
                        activeMenu: '/legalAffairs/toolBox/index',
                        modules: [13101]
                    }
                },
                {
                    path: 'resouceDetail/:id',
                    name: 'TbResouceDetail',
                    hidden: true,
                    component: () => import('@/views/legalAffairs/resource/resourceContract/contractDetail'),
                    meta: {
                        title: '资源合同详情',
                        activeMenu: '/legalAffairs/toolBox/index',
                        modules: [13101],
                        isDetail: true
                    }
                },
                {
                    path: 'offlineSale',
                    name: 'OfflineSaleContractDelivery',
                    hidden: true,
                    component: () => import('@/views/legalAffairs/toolBox/offlineSale'),
                    meta: {
                        title: '线下销售合同交接',
                        keepAlive: true,
                        activeMenu: '/legalAffairs/toolBox/index',
                        modules: [13102]
                    }
                },
                {
                    path: 'offlineSaleDetail/:id',
                    name: 'TbOfflineSaleDetail',
                    hidden: true,
                    component: () => import('@/views/legalAffairs/sales/offlineContract/contractDetail'),
                    meta: {
                        title: '销售合同详情',
                        activeMenu: '/legalAffairs/toolBox/index',
                        modules: [13102],
                        isDetail: true
                    }
                },
                {
                    path: 'onlineSale',
                    name: 'OnlineSaleContractDelivery',
                    hidden: true,
                    component: () => import('@/views/legalAffairs/toolBox/onlineSale'),
                    meta: {
                        title: '线上销售合同交接',
                        keepAlive: true,
                        activeMenu: '/legalAffairs/toolBox/index',
                        modules: [13103]
                    }
                },
                {
                    path: 'onlineSaleDetail/:id',
                    name: 'TbOnlineSaleDetail',
                    hidden: true,
                    component: () => import('@/views/legalAffairs/sales/onlineContract/contractDetail'),
                    meta: {
                        title: '销售合同详情',
                        activeMenu: '/legalAffairs/toolBox/index',
                        modules: [13103],
                        isDetail: true
                    }
                },
                {
                    path: 'offlineOutsource',
                    name: 'OfflineOutsourceContractDelivery',
                    hidden: true,
                    component: () => import('@/views/legalAffairs/toolBox/offlineOutsource'),
                    meta: {
                        title: '线下外采合同交接',
                        keepAlive: true,
                        activeMenu: '/legalAffairs/toolBox/index',
                        modules: [13104]
                    }
                },
                {
                    path: 'onlineOutsource',
                    name: 'OnlineOutsourceContractDelivery',
                    hidden: true,
                    component: () => import('@/views/legalAffairs/toolBox/onlineOutsource'),
                    meta: {
                        title: '线上外采合同交接',
                        keepAlive: true,
                        activeMenu: '/legalAffairs/toolBox/index',
                        modules: [13105]
                    }
                },
                {
                    path: 'outsourceDetail/:id',
                    name: 'TbOutsourceDetail',
                    hidden: true,
                    component: () => import('@/views/legalAffairs/outsource/offlineContract/contractDetail'),
                    meta: {
                        title: '外采合同详情',
                        activeMenu: '/legalAffairs/toolBox/index',
                        modules: [13105],
                        isDetail: true
                    }
                },
                {
                    path: 'generalContract',
                    name: 'GeneralContractDelivery',
                    hidden: true,
                    component: () => import('@/views/legalAffairs/toolBox/generalContract'),
                    meta: {
                        title: '通用合同交接',
                        keepAlive: true,
                        activeMenu: '/legalAffairs/toolBox/index',
                        modules: [13106]

                    }
                }
            ]
        }
    ]
};
